import type { Experience } from '../types';

export const experience: Experience[] = [
  {
    id: 'obsidianos',
    company: 'ObsidianOS',
    role: 'Lead Full Stack Developer',
    roleKey: 'experience.roles.leadFullStack',
    startDate: '2025-09',
    descriptionKey: 'experience.obsidianos.description',
    technologies: ['React', 'TypeScript', 'Zustand', 'TanStack Query', 'Vite', 'Tailwind', 'react-testing-library'],
    type: 'professional',
  },
  {
    id: 'katana',
    company: 'Katana Manufacturing ERP',
    role: 'Senior Software Engineer',
    roleKey: 'experience.roles.seniorEngineer',
    startDate: '2022-01',
    endDate: '2025-05',
    descriptionKey: 'experience.katana.description',
    technologies: ['PostgreSQL', 'Node.js', 'React', 'Redux', 'Miro'],
    type: 'professional',
  },
  {
    id: 'netgroup',
    company: 'Net Group',
    role: 'Full Stack Engineer',
    roleKey: 'experience.roles.fullStack',
    startDate: '2018-08',
    endDate: '2022-12',
    descriptionKey: 'experience.netgroup.description',
    technologies: ['Java', 'Spring', 'Spring Batch', 'PostgreSQL', 'Flyway', 'React', 'MobX', 'JUnit5', 'Jest'],
    type: 'professional',
  },
  {
    id: 'travelwiser',
    company: 'TravelWiser',
    role: 'Frontend Developer',
    roleKey: 'experience.roles.frontend',
    startDate: '2018-03',
    endDate: '2018-10',
    descriptionKey: 'experience.travelwiser.description',
    technologies: ['React', 'Redux', 'Bootstrap', 'CSS'],
    type: 'professional',
  },
  {
    id: 'ibkrates',
    company: 'IB Krates',
    role: 'Full Stack Developer Trainee',
    roleKey: 'experience.roles.trainee',
    startDate: '2017-10',
    endDate: '2018-02',
    descriptionKey: 'experience.ibkrates.description',
    technologies: ['Java', 'GWT'],
    type: 'professional',
  },
  {
    id: 'itcollege',
    company: 'Estonian IT College Student Union',
    role: 'Manager / Head',
    roleKey: 'experience.roles.manager',
    startDate: '2016-06',
    endDate: '2017-08',
    descriptionKey: 'experience.itcollege.description',
    technologies: [],
    type: 'leadership',
  },
  {
    id: 'ribs',
    company: 'Rolling Images in Business Startups (RIBS)',
    role: 'Mentor & Manager',
    roleKey: 'experience.roles.mentor',
    startDate: '2016-03',
    endDate: '2018-03',
    descriptionKey: 'experience.ribs.description',
    technologies: [],
    type: 'leadership',
  },
  {
    id: 'sak',
    company: 'Saaremaa Arenduskeskus (SAK)',
    role: 'Mentor & Manager',
    roleKey: 'experience.roles.mentor',
    startDate: '2014-11',
    endDate: '2016-05',
    descriptionKey: 'experience.sak.description',
    technologies: [],
    type: 'leadership',
  },
  {
    id: 'studery',
    company: 'Studery',
    role: 'Co-Founder',
    roleKey: 'experience.roles.cofounder',
    startDate: '2012-10',
    endDate: '2015-09',
    descriptionKey: 'experience.studery.description',
    technologies: ['Android'],
    type: 'entrepreneurship',
  },
  {
    id: 'nycpianobar',
    company: 'NYC Piano Bar',
    role: 'Cook / Head Chef',
    roleKey: 'experience.roles.chef',
    startDate: '2014-06',
    endDate: '2014-08',
    descriptionKey: 'experience.nycpianobar.description',
    technologies: [],
    type: 'other',
  },
];
